import { Id, PagedMultiSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC, useMemo } from "react";
import { UserSelectOption } from "../../../shared/ui/UserSelectOption";
import { createApplicationUserService } from "../shared/api/userService";

interface Props {
	applicationId: Id;
	name: string;
	label: string;
}

export const ApplicationUserMultiSelect: FC<Props> = ({ applicationId, name, label }) => {
	const applicationUserService = useMemo(() => createApplicationUserService(applicationId), [applicationId]);

	return (
		<PagedMultiSelectField
			name={name}
			label={label}
			fetchConfig={laravelSelectFetchConfig(applicationUserService.getAvailableUsersKey, (search, page) =>
				applicationUserService.getAvailableUsers(search, page).then((r) => r.data),
			)}
			getLabel={(x) => x.name}
			renderOption={(x, isSelected) => <UserSelectOption isSelected={isSelected} user={x} />}
		/>
	);
};
